import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { FadeUp, MaskedLines } from "./Motion";
import { usePhone } from "../../lib/content";
import { trackCta } from "../../lib/analytics";

export function FinalCTA() {
  const phone = usePhone();
  return (
    <section className="noise relative isolate overflow-hidden py-28 lg:py-44" data-testid="final-cta-section">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-1/2 top-full h-[900px] w-[1300px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-electric/30 blur-[160px]" />
        <div className="absolute inset-0 grid-lines [mask-image:radial-gradient(ellipse_at_50%_100%,#000_10%,transparent_65%)]" />
      </div>
      <div className="container-x text-center">
        <p className="eyebrow">One last thing</p>
        <MaskedLines as="h2" inView
          lines={["Your Next Customer", <>Could Be <span className="font-serif italic font-normal text-gradient">One Ad Away.</span></>]}
          className="mx-auto mt-6 max-w-5xl text-[2.5rem] leading-[1] sm:text-6xl lg:text-[6rem] font-semibold tracking-[-0.045em] text-white" />
        <FadeUp delay={0.2}>
          <p className="mx-auto mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-300">
            Stop spending your time figuring out Facebook ads. We handle the scripting, filming, editing, campaign management, and lead generation so you can focus on running your business.
          </p>
        </FadeUp>
        <FadeUp delay={0.3} className="mt-10 flex flex-col items-center gap-5">
          <Link to="/get-started" data-testid="final-cta-btn" onClick={() => trackCta("Let's Grow Your Business", "final")} className="btn-primary group !px-8 !py-4 !text-base">
            Let's Grow Your Business <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <a href={`tel:${phone.tel}`} data-testid="final-cta-phone-link" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white">
            <Phone className="h-4 w-4 text-cyan-300" /> Prefer to Talk? Call or Text <span className="font-semibold text-white">{phone.display}</span>
          </a>
        </FadeUp>
      </div>
    </section>
  );
}
